import { useCallback, useEffect, useState } from 'react';
import type { Streak } from '../types/api';
import { useApi } from './client';

interface UseStreakResult {
  streak: Streak | null;
  error: string | null;
  reload: () => Promise<void>;
}

export function useStreak(): UseStreakResult {
  const apiFetch = useApi();
  const [streak, setStreak] = useState<Streak | null>(null);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    try {
      const r = await apiFetch('/streak');
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data: Streak = await r.json();
      setStreak(data);
      setError(null);
    } catch (e) {
      setError(String(e));
    }
  }, [apiFetch]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { streak, error, reload };
}